import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { theme } from '@openx/components-core/lib/theme/theme.ts';
import { abbreviateNumericValue } from '@openx/utils/lib/abbreviateNumericValue.ts';
import { useTranslation } from 'react-i18next';

interface SingleReasonDisplayProps {
  discardedPercentage: string;
  reason: string;
  discardedValueNumeric: number;
  volumeColumnLabel: string;
}

export const SingleReasonDisplay = ({
  discardedPercentage,
  discardedValueNumeric,
  reason,
  volumeColumnLabel,
}: SingleReasonDisplayProps) => {
  const { t } = useTranslation();
  return (
    <Box
      sx={{
        columnGap: theme.spacing(3),
        display: 'grid',
        gridTemplateColumns: 'auto fit-content(100%) fit-content(100%)',
        rowGap: theme.spacing(0.5),
      }}
      data-test="funnel-step-single-reason"
    >
      {/* Header Row */}
      <Box>
        <Typography variant="body2Bold">{t('Reason')}</Typography>
      </Box>
      <Box>
        <Typography variant="body2Bold">{volumeColumnLabel}</Typography>
      </Box>
      <Box>
        <Typography variant="body2Bold">{t('% of Filtered')}</Typography>
      </Box>

      {/* Content Row */}
      <Box>
        <Typography variant="body2" data-test="reason">
          {t(reason)}
        </Typography>
      </Box>
      <Box>
        <Typography variant="body2" data-test="volume">
          {abbreviateNumericValue(Number(discardedValueNumeric), { allowZero: true })}
        </Typography>
      </Box>
      <Box>
        <Typography variant="body2" data-test="percentage">
          {discardedPercentage}
        </Typography>
      </Box>
    </Box>
  );
};
